import type {
    ISlider,
    ISliderOptions
} from './types';
// @ts-ignore
import {RESIZE_EVENTS} from '@/common/scripts/constants';
import SwiperSlider from '../../components/swiper-slider';
import {Utils} from '@/common/scripts/utils';

class ContentSlider implements ISlider {
    wrapper: HTMLElement;
    sliderWrapper: HTMLElement | null;
    sliderCarouselWrapper: HTMLElement | null;
    slides: HTMLElement[];
    prevIndexSlide: number;
    slider: SwiperSlider;
    navigation: HTMLElement;
    baseSettings: any;

    init(options: ISliderOptions): void {
        this.wrapper = options.wrapper;

        this.setElements();
        this.initSlider(options.sliderSettings);
        this._bindEvents();
    }

    /**
     * Получает зависимости (элементы) для работы слайдера
     */
    setElements(): void {
        if (!this.wrapper) {
            return;
        }

        this.sliderWrapper = this.wrapper.querySelector('.j-content-slider');
        this.slides = [...this.wrapper.querySelectorAll('.j-content-slider-item')] as HTMLElement[];
        this.navigation = this.wrapper.querySelector('.j-content-slider-nav') as HTMLElement;
    }

    /**
     * Инициализируем сам слайдер
     * @param {Object} customSettings - кастомные настройки слайдера
     */
    /* eslint-disable */
    initSlider(customSettings: Record<string, boolean | string | number> = {}): void {
        if (!this.sliderWrapper) {
            return;
        }

        if (window.innerWidth >= 670) {
            const nextEl = this.wrapper.querySelector('.j-content-slider-next');
            const prevEl = this.wrapper.querySelector('.j-content-slider-prev');

            this.baseSettings = {
                wrapperClass  : 'j-content-slider-inner',
                slideClass    : 'j-content-slider-item',
                loop          : true,
                effect        : 'fade',
                fadeEffect: {
                    crossFade: true
                },
                slidesPerView : 1,
                speed         : 1000,
                navigation    : {
                    nextEl,
                    prevEl
                },
                breakpoints: {
                    320: {
                        enabled: false,
                    },
                    675: {
                        enabled: true,
                    }
                }
            }

            this.slider = new SwiperSlider({
                item    : this.sliderWrapper,
                settings: {
                    ...this.baseSettings,
                    ...customSettings
                }
            });

            this.slider.init();
        }
    }
    /* eslint-enable */

    private _bindEvents(): void {
        RESIZE_EVENTS.forEach((event: string): void => {
            window.addEventListener(event, Utils.debounce(this.initSlider.bind(this), 100));
        });
    }
}

export default ContentSlider;
